import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomValidator } from 'src/app/shared/services/custom-validatior.abstract';
import { ToastService } from 'src/app/shared/services/toast.service';
import { SuperAdminService } from '@core/services/super-admin.service';
import {
  DEFAULT_PP,
  Invalid_IMAGE_FORMAT,
  SPOT_TYPE_LABEL,
} from '../../constant/shared.constant';
import { FileResponse } from '@core/models/file-response.model';
import { ParkingService } from '../parking-lot/services/parking.service';
import { VehicleTypeDetail } from '@core/models/vehicle-type-detail.model';
import { Dropdown } from 'primeng/dropdown';
import { CommonFunctions } from '@shared/common-functions';
import { ProfileService } from '@core/services/profile.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
interface YearOption {
  key: number;
  value: number;
}
@Component({
  selector: 'app-vehicle-type-modal',
  templateUrl: './vehicle-type-modal.component.html',
  styleUrls: ['./vehicle-type-modal.component.scss'],
})
export class VehicleTypeModalComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  @ViewChild('dropdown') dropdown: Dropdown;
  comingFrom: string;
  items;
  years: YearOption[] = [];
  truckTypes: VehicleTypeDetail[] = [];
  driverId: string = '';
  currentLicenseNumberPlate: any;
  vehicleForm: FormGroup;
  isProfileImgError = false;
  formData: FormData = new FormData();
  isLoading = false;
  imageUrl: string = '';
  dummy: string = DEFAULT_PP;
  isEditForm: boolean = false;
  EquipmentDescription: string = '';
  checkEquipmentTypeSelected: boolean = false;
  truckType: any = [];
  spotTypeMsg: string = SPOT_TYPE_LABEL;
  Additionallp: any = `<p>You can add multiple LP Numbers separated by commas. (e.g.
    658987855, 4555455555)</p>`;
  colors: string[] = [
    'Black',
    'Blue',
    'Brown',
    'Gray',
    'Orange',
    'Purple',
    'Red',
    'Silver',
    'White',
    'Other',
  ];
  makes: { name: string }[] = [
    { name: 'Chevy' },
    { name: 'Ford' },
    { name: 'Freightliner' },
    { name: 'GMC' },
    { name: 'Hino' },
    { name: 'International' },
    { name: 'Isuzu' },
    { name: 'Kenworth' },
    { name: 'Mack' },
    { name: 'Peterbilt' },
    { name: 'Volvo' },
    { name: 'Western Star' },
    { name: 'Other' },
  ];

  constructor(
    private readonly fb: FormBuilder,
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly superAdminService: SuperAdminService,
    public readonly toastService: ToastService,
    private readonly service: ProfileService,
    private readonly parkingService: ParkingService
  ) { }

  ngOnInit() {
    this.getYearsObj();
    this.getVehicleTypeList();
    this.truckType = this.config.data.truckType;
    this.comingFrom = this.config.data.comingFrom;

    this.vehicleForm = this.fb.group({
      vehicleType: [this.truckType],
      make: ['', [Validators.required, Validators.minLength(3)]],
      model: ['', [Validators.minLength(3)]],
      color: ['', [Validators.required, Validators.minLength(3)]],
      year: [''],
      trailerNumber: ['', [Validators.minLength(3), Validators.pattern('^[A-Za-z0-9!@#$%^&*()_+\\-=\\[\\]{};:\'",.<>?/]+$')]],
      companyName: ['', [Validators.minLength(3)]],
      dotNumber: ['', [Validators.maxLength(12), Validators.minLength(6)]],
      licenseNumberPlate: [
      '',
      [
        Validators.required,
        Validators.maxLength(15),
        Validators.minLength(5),
        Validators.pattern('^[A-Za-z0-9]+$')
      ],
      ],
      additionalLicenseNumberPlate: ['', [Validators.minLength(5)]],
      mcNumber: ['', [Validators.maxLength(15), Validators.minLength(6)]],
    });

    if (this.config.data.data) {
      this.isEditForm = true;
      this.vehicleForm.patchValue(this.config.data.data);
      this.EquipmentDescription =
        this.config.data.data?.vehicleType?.description;
      this.imageUrl = this.config.data.data.vehicleImage;
    }
    if (this.comingFrom === 'createBookingSection') {
      this.vehicleForm.get('vehicleType').disable();
      this.vehicleForm.get('vehicleType').patchValue(this.truckType);
    }

    this.driverId = this.config.data.driverId;
    this.updateValidations();
  }

  updateValidations() {
      this.vehicleForm
        .get('mcNumber')
        .setValidators([Validators.maxLength(15), Validators.minLength(6)]);
      this.vehicleForm
        .get('dotNumber')
        .setValidators([
          Validators.maxLength(12),
          Validators.minLength(6),
        ]);
      this.vehicleForm.get('mcNumber').updateValueAndValidity();
      this.vehicleForm.get('dotNumber').updateValueAndValidity();
  }

  preventFirstSpace(event: KeyboardEvent): void {
      CommonFunctions.preventFirstSpaces(event);
    }

  onColorInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const filteredValue = inputElement.value.replace(/[^A-Za-z]/g, '');
    this.vehicleForm
      .get('color')
      ?.setValue(filteredValue, { emitEvent: false });
  }

  cancelDialog(): void {
    this.ref.close();
  }

  clearImage() {
    this.imageUrl = '';
    this.formData.delete('Images');
    this.isProfileImgError = false;
    const fileInput = document.getElementById('imageInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  getYearsObj() {
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 2000; year--) {
      this.years.push({ key: year, value: year });
    }
  }

  get f() {
    return this.vehicleForm.controls;
  }

  onTruckTypeChange(event) {
    this.updateValidations();
    this.EquipmentDescription = event.value?.description;
  }
  saveAndSelect(): void {
    if (this.vehicleForm.valid && this.vehicleForm.get('vehicleType').value) {
      
      const request = this.constructVehicleRequest();
      this.superAdminService.createNewVehicleForDriver(request).pipe(autoUnsubWith(this.destroyRef)).subscribe({
        next: async (response: any) => {
          this.handleSuccess(response);
          
        },
        error: (error) => {
          this.handleError(error); 
        },
      });
    } else {
      if (!this.vehicleForm.get('vehicleType').value) {
        this.toastService.showToastMessage(
          'error',
          'Error',
          'Please select spot type.'
        );
      }
      CustomValidator.markFormGroupTouched(this.vehicleForm);
    }
  }

  constructVehicleRequest(): any {
    return {
      vehicleImage: this.imageUrl,
      mcNumber: this.vehicleForm.value.mcNumber,
      licenseNumberPlate: this.vehicleForm.value.licenseNumberPlate,
      additionalLicenseNumberPlate:
        this.vehicleForm.value.additionalLicenseNumberPlate,
      make: this.vehicleForm.value.make,
      trailerNumber: this.vehicleForm.value.trailerNumber,
      companyName: this.vehicleForm.value.companyName,
      model: this.vehicleForm.value.model,
      color: this.vehicleForm.value.color,
      year: this.vehicleForm.value.year || 0,
      vehicleTypeId:
        this.comingFrom === 'createBookingSection'
          ? this.truckType[0].id
          : this.vehicleForm.value.vehicleType.id,
      driverId: this.driverId,
      dotNumber: this.vehicleForm.value.dotNumber,
    };
  }

  handleSuccess(response: any): void {
    this.getAllvehicleByDriverId();
    this.toastService.showToastMessage('success', 'Success', response.message);
    this.currentLicenseNumberPlate = response.data?.licenseNumberPlate;
  }

  handleError(error: any): void {
    const errorMessage = error.error?.message;
    this.toastService.showToastMessage('error', 'Error', errorMessage);
  }

  getVehicleTypeList() {
    this.parkingService.getVehicleTypeList().pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: async (types: VehicleTypeDetail[]) => {
        this.truckTypes = types; 
      }
    });
  }

  onKeyPress(event: KeyboardEvent): void {
    const allowedChars = /[0-9\.]/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

  getAllvehicleByDriverId() {
    const req = {
      vehicleTypeId:
        this.comingFrom === 'createBookingSection'
          ? this.truckType[0].id
          : this.vehicleForm.value.vehicleType.id,
      driverId: this.driverId,
    };

    this.superAdminService.getAllVehiclesByDriverId(req).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (response: any) => {
        if (response.data) {
          response.data.currentLicenseNumberPlate =
            this.currentLicenseNumberPlate;
        } else {
          response.data = {
            currentLicenseNumberPlate: this.currentLicenseNumberPlate,
          };
        }
        this.ref.close(response);
      }
    });
  }

  onImageSelected(event: any) {
    const files = event.target.files[0];
    const maxSize = 5 * 1024 * 1024; // 5MB
    const allowedExtensions = ['jpg', 'jpeg', 'png'];

    if (files.size > maxSize) {
      this.isProfileImgError = true;
      return;
    }

    const fileExtension = files.name.split('.').pop()?.toLowerCase();
    if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
      this.toastService.showToastMessage(
        'error',
        'Error',
        Invalid_IMAGE_FORMAT
      );
      return;
    }
    this.isProfileImgError = false;
    this.vehicleForm.get('vehicleImage')?.setValue(files);

    this.formData.append('Images', files);
    this.isLoading = true;
    this.service.imageUplaod(this.formData).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (response: FileResponse) => {
        const data = response;
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const url = data[key];
            this.imageUrl = url;
            this.vehicleForm.get('vehicleImage')?.setValue(url);
          }
        }
        this.isLoading = false;
      },
      error: (_error) => {
        this.isProfileImgError = false;
        this.isLoading = false;
      },
    });
  }

  onEdit() {
    if (this.comingFrom !== 'DriverProfileSection') {
      if (this.vehicleForm.valid) {
        
        const request = {
          vehicleImage: this.imageUrl,
          mcNumber: this.vehicleForm.value.mcNumber,
          licenseNumberPlate: this.vehicleForm.value.licenseNumberPlate,
          additionalLicenseNumberPlate:
            this.vehicleForm.value.additionalLicenseNumberPlate,
          make: this.vehicleForm.value.make,
          trailerNumber: this.vehicleForm.value.trailerNumber,
          companyName: this.vehicleForm.value.companyName,
          model: this.vehicleForm.value.model,
          color: this.vehicleForm.value.color,
          year: this.vehicleForm.value.year || 0,
          vehicleTypeId: this.vehicleForm.value.vehicleType?.id || '',
          vehicleId: this.config.data.data?.id || '',
          driverId: this.driverId || '',
          dotNumber: this.vehicleForm.value.dotNumber,
        };
        this.superAdminService
          .EditVehicleForDriverBySuperAdmin(request)
          .pipe(autoUnsubWith(this.destroyRef)).subscribe({
            next: async (response: any) => {
              this.handleSuccess(response);
              
            },
            error: (error) => {
              this.handleError(error);
            },
          });
      } else {
        CustomValidator.markFormGroupTouched(this.vehicleForm);
      }
    } else if (this.comingFrom === 'DriverProfileSection') {
      if (this.vehicleForm.valid) {
        
        const request = {
          vehicleImage: this.imageUrl,
          mcNumber: this.vehicleForm.value.mcNumber,
          licenseNumberPlate: this.vehicleForm.value.licenseNumberPlate,
          additionalLicenseNumberPlate: this.vehicleForm.value.additionalLicenseNumberPlate,
          trailerNumber: this.vehicleForm.value.trailerNumber,
          companyName: this.vehicleForm.value.companyName,
          make: this.vehicleForm.value.make,
          model: this.vehicleForm.value.model,
          color: this.vehicleForm.value.color,
          year: this.vehicleForm.value.year || 0,
          vehicleTypeId: this.vehicleForm.value.vehicleType.id || '',
          driverId: null,
          dotNumber: this.vehicleForm.value.dotNumber,
        };
        this.superAdminService.createNewVehicleForDriver(request).pipe(autoUnsubWith(this.destroyRef)).subscribe({
          next: async (response: any) => {
            this.handleSuccess(response);
            
          },
          error: (error) => {
            this.handleError(error);
          },
        });
      } else {
        CustomValidator.markFormGroupTouched(this.vehicleForm);
      }
    }
  }

  openDropdown() {
    this.dropdown.show();
  }
}
